import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { adminLogin, confirmAuth } from "../api/auth";

interface AuthContextType {
  isAuthenticated: boolean;
  setAuthenticated: (auth: boolean) => void;
  checkAuth: () => Promise<void>;
  login: (username: string, password: string) => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setAuthenticated] = useState(false);

  // Check authentication status on mount
  const checkAuth = async () => {
    try {
      const result = await confirmAuth();
      setAuthenticated(!!result);
    } catch (err) {
      setAuthenticated(false);
      console.log("Auth check failed", err);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  // Login method
  const login = async (username: string, password: string) => {
    try {
      const res = await adminLogin(username, password);
      if (res && res.token) {
        sessionStorage.setItem("adminToken", res.token);
        setAuthenticated(true);
        return true;
      }
      setAuthenticated(false);
      return false;
    } catch (err) {
      setAuthenticated(false);
      return false;
    }
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setAuthenticated, checkAuth, login }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
